import React, { useEffect, useRef, useState } from "react";
import LoginHome from "../Comps/LogIn/LoginHome";
import aug15Video from "../../src/img/aug15Vid.mp4";

const Login = () => {
  // const [hideVideo, setHideVideo] = useState(false);
  // const videoRef = useRef(null);

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setHideVideo(true);
  //   }, 8000);

  //   return () => {
  //     clearTimeout(timer);
  //   };
  // }, []);

  return (
    <div
      className="mb-0 pb-0 position-relative "
      style={{
        background: "linear-gradient(to top, #87ceeb, #ffffff)",
        //   position: "relative",
        //   width: "100%",
        height: "100vh",
        //   overflow: "hidden",
      }}
    >
      <div
        className=""
        style={{
          // position: "absolute",
          inset: 0,

          // opacity: hideVideo ? 1 : 0,
          transition: "opacity 1.5s ease-in-out",

          zIndex: 1,
        }}
      >
        <LoginHome />
      </div>
    </div>
  );
};

export default Login;
